import { render } from "./SellChannel.vue?vue&type=template&id=1e74e513&scoped=true"
import script from "./SellChannel.vue?vue&type=script&lang=js"
export * from "./SellChannel.vue?vue&type=script&lang=js"

import "./SellChannel.vue?vue&type=style&index=0&id=1e74e513&scoped=true&lang=css"

import exportComponent from "/home/vovan/Документы/Projects/taho-crm-git/Taho-Front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e74e513"]])

export default __exports__